// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"f191e084","209":"7c8233ea"}[chunkId] + ".chunk.js";
};